/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyPermissionsResponse } from '../../models/my-permissions-response';

export interface AuthzMyPermissions$Json$Params {
}

export function authzMyPermissions$Json(http: HttpClient, rootUrl: string, params?: AuthzMyPermissions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MyPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, authzMyPermissions$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MyPermissionsResponse>;
    })
  );
}

authzMyPermissions$Json.PATH = '/api/v1/auth/me/permissions';
